import { useQuery } from "@tanstack/react-query";
import { api } from "../../api";

export function useReturningOrgs(fromDate: string, toDate: string) {
  return useQuery({
    queryKey: ["platformAnalytics", "returningOrgs", fromDate, toDate],
    queryFn: () =>
      api.getReturningOrgs({ from_date: fromDate, to_date: toDate }),
  });
}
